import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./auth/Login";
import Signup from "./auth/Signup";
import Home from "./pages/Home";
import Library from "./pages/Library";
import Search from "./pages/Search";
// import Song from "./pages/Song";
import UserLayout from "./pages/UserLayout";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home />} />
          <Route path="/search" element={<Search />} />
          {/* <Route path="/song/:id" element={<Song />} /> */}
          <Route path="/library" element={<Library />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default App;
